import { NgClass } from '@angular/common';
import { Component, effect, Input, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { LocalStorageKeys } from '@iot-platform/core';
import { HeaderComponent as SharedHeaderComponent } from '@iot-platform/feature/app-shell';
import { BusinessProfile } from '@iot-platform/models/common';
import { TranslatePipe } from '@ngx-translate/core';
import moment from 'moment';

@Component({
  imports: [MatTooltip, MatSelectModule, MatMenuModule, MatDivider, MatIcon, TranslatePipe, FlexLayoutModule, MatButtonModule, NgClass, ReactiveFormsModule],
  selector: 'oyan-ui-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../../../../../../iot-platform/iot-platform-feature-app-shell/src/lib/components/header/header.component.scss', './header.component.scss']
})
export class HeaderComponent extends SharedHeaderComponent {
  @Input() appLogo: string;

  constructor() {
    super();

    this.initSelectedBPEffect();
  }

  initSelectedBPEffect(): void {
    effect(() => {
      const bp: BusinessProfile = this.selectedBusinessProfile();

      // Store emits a `{ id: null }` placeholder before the session is restored; persisting it would wipe the stored business profile
      if (bp?.id) {
        this.storage.set(
          LocalStorageKeys.STORAGE_BUSINESS_PROFILE_KEY,
          JSON.stringify({
            ...bp,
            timezone: moment(new Date()).format('Z'),
            timezoneDetails: { name: null, offset: null }
          })
        );
      }
    });
  }
}
